/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

interface Logoicon3Props {
  className?: string;
}

export const Logoicon3: React.FC<Logoicon3Props> = ({ className }) => {
  return (
    <svg
      className={`logoicon-3 ${className}`}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect className="rect" fill="#0D2B7E" height="24" rx="3.31034" width="24" y="0.000244141" />
      <path
        className="path"
        d="M15.152 18.4569C18.1007 17.5915 20.2499 14.6902 20.2499 11.5156C20.2499 7.64115 17.0486 4.50027 13.0997 4.50027C9.4951 4.50027 6.51347 7.11734 6.02095 10.5205H8.4932C8.89795 8.22775 10.8285 6.49044 13.149 6.49044C15.7635 6.49044 17.8829 8.69574 17.8829 11.4161C17.8829 14.1365 15.5812 16.3387 13.0997 16.5859C12.5962 16.6108 12.1227 16.6108 11.6295 16.6108H7.95893C8.04862 16.7129 7.86348 16.5139 7.95893 16.6108H6.71131V18.7502H11.6671C12.1602 18.7502 12.5944 18.7502 13.0997 18.7502C13.6214 18.7502 14.1299 18.6954 14.6198 18.5913C14.8065 18.5725 14.9852 18.5263 15.152 18.4569Z"
        fill="white"
      />
      <path className="path" d="M4.5 13.9271H11.4529V15.9002H4.5V13.9271Z" fill="white" />
      <path className="path" d="M6.02095 11.1868H10.5838V13.1598H6.02095V11.1868Z" fill="white" />
    </svg>
  );
};
